const initialState = {
  subject: null,
  //subjectIds: [],
  earliestDate: '',
  latestDate: '',
  ascending: true,
  includeCancelled: false,
};

export default initialState;
